import {platform, previewMode, storeID as store, uuid as storeUUID} from "../store"
import getScriptParams from "../../utils/getScriptParams";
import {setReporting} from "./setReporting";
import sendReady from "./sendReady";
import type {Platform} from "@fast-simon/types";

export default function setCredentials() {
    const params = getScriptParams("fs-recommendations-init.js");
    if (params) {
        storeUUID.set(params.get("uuid"));
        store.set(Number(params.get('store_id') || params.get('store')));
        platform.set(<Platform>params.get('platform'));
        if (params.has('preview')) {
            previewMode.set(true);
        }
        setReporting();
        sendReady();
    }
    else {
        console.error("Could not find store_id and uuid in the URL");
    }
}